import type { App } from 'vue';
let cachedPermissions: string[] = []
import {getSelect as getUserPermissionsApi} from '@/api/api.ts'
export default {
    async  install(app: App) {
        console.log('注册 plugins 插件')
        // 判断当前路径是否为登录页，比如 /login
        const isLoginPage = window.location.pathname === '/login'
        if (!isLoginPage) {
            // 第一步：初始化权限
            await fetchUserPermissions()


            // 下面是动态加载 Profile 组件的逻辑
            const profileModule = await import('@/pages/admin/settings/profile.vue')  // 动态导入组件
            app.component('Profile', profileModule.default)  // 注册为全局组件
        }

        // 第二步：注册全局指令
        app.directive('permission', {
            beforeMount(el, binding) {
                const value = binding.value
                if (!cachedPermissions.includes(value)) {
                    el.style.display = 'none'
                }
            }
        });
    }
}
// 异步获取权限并缓存
async function fetchUserPermissions() {
    try {
        const res = await getUserPermissionsApi('/api/v1/admin/system/rule') // 你实际的权限请求 API
        console.log(res)
        if (res.status) {
            cachedPermissions = Object.values(res.data)
        } else {
            cachedPermissions = []
            console.warn('权限获取失败：')
        }
    } catch (e) {
        console.error('权限加载异常:', e)
        cachedPermissions = []
    }
}